import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiState } from '../../../types/api';
import { RootState } from '../..';

export interface IGetAllowedBusinessTypesResponse {
  status?: boolean;
  message?: string;
  data: string[];
}

const initialState: IApiState<IGetAllowedBusinessTypesResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getAllowedBusinessTypesAsync = createAsyncThunk(
  'allowedBusinessTypes/get',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;
      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
        },
      };

      const { data } = await api.get(
        '/business/allowed-business-types',
        config
      );

      return data;
    } catch (err) {
      const error = err as AxiosError<IGetAllowedBusinessTypesResponse>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const allowedBusinessTypesFetch = createSlice({
  name: 'allowedBusinessTypes/fetch',
  initialState,
  reducers: {
    resetAllowedBusinessTypes: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllowedBusinessTypesAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getAllowedBusinessTypesAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IGetAllowedBusinessTypesResponse;
      })
      .addCase(getAllowedBusinessTypesAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IGetAllowedBusinessTypesResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetAllowedBusinessTypes } = allowedBusinessTypesFetch.actions;
export default allowedBusinessTypesFetch.reducer;
